import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { InViewDirective } from '../../../core/directives/in-view.directive';

@Component({
  selector: 'app-business-info',
  standalone: true,
  imports: [MatIconModule, MatRippleModule, InViewDirective],
  templateUrl: './business-info.component.html',
  styleUrl: './business-info.component.scss'
})
export class BusinessInfoComponent {

}
